import { createFileRoute, redirect } from '@tanstack/react-router'
import { PreviousTutorial } from '@/components/installFlowV2/previous-tutorial'
import { z } from 'zod'
import { isAuthenticated } from '@/auth';
export const Route = createFileRoute('/installFlow/previous-tutorial')({
  component: PreviousTutorial,
  validateSearch: z.object({
    redirect: z.string().optional().catch(""),
    installSensorKitSerialNumber: z.string().optional(),
  }),
  beforeLoad: ({ search }) => {
    const authenticated = isAuthenticated();
    if (!authenticated) {
      throw redirect({ to: "/login" });
    }
  },
})


